import React, {FC} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {PaymentRequestButtonElement} from '@stripe/react-stripe-js';
import {PaymentRequest} from '@stripe/stripe-js';
import classNames from 'classnames';
import {connect} from 'react-redux';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {PlacingOrderScreen} from 'desktop/components/placingOrderScreen/placingOrderScreen';
import {PaymentStepAgreement} from 'desktop/pages/checkout/components/paymentStepAgreement/paymentStepAgreement';
import {
    getApplePayInnerError,
    getApplePayIsLoading,
    getApplePayOrderError,
    getPaymentDetailsWithoutShipping,
} from 'desktop/pages/checkout/store/selectors/paymentStep/applePay/applePay';
import {ApplicationStoreType} from 'desktop/store';
import {PaymentDetailsType} from 'types/applePayType';

import s from './paymentApplePayButton.scss';

export type PropsType = {
    paymentRequest: PaymentRequest;
    paymentDetails: PaymentDetailsType;
    isLoading: boolean;
    errorMessage?: string | boolean;
    innerApplePayError: string | null;
    shippingProtectionPrice?: number;
};

/**
 * Payment ApplePay Button for checkout
 */
export const PaymentApplePayButton: FC<PropsType> = ({
    errorMessage,
    innerApplePayError,
    isLoading,
    paymentDetails,
    paymentRequest,
    shippingProtectionPrice,
}) => {
    const onClick = () => {
        let paymentDetailsData = {...paymentDetails};
        sendDesktopAnalyticsEvent(
            CHECKOUT_PAYMENT_STEP,
            {
                message: 'CTA - Apple pay',
                method: 'Payment',
            },
            true,
        );
        if (shippingProtectionPrice) {
            paymentDetailsData = {
                ...paymentDetails,
                displayItems: [
                    ...paymentDetails.displayItems,
                    {
                        amount: Number((shippingProtectionPrice * 100).toFixed(0)),
                        label: 'Shipping Protection',
                    },
                ],
            };
        }

        paymentRequest?.update(paymentDetailsData);
    };

    return (
        <>
            <p className={classNames(s.text, s.margin)}>
                Click the button to be redirected to Apple Pay & complete your purchase.
                <PaymentStepAgreement className={s.text} />
            </p>
            <div className={s.btnWrapper}>
                <PaymentRequestButtonElement
                    options={{
                        paymentRequest,
                        style: {
                            paymentRequestButton: {
                                type: 'buy',
                            },
                        },
                    }}
                    onClick={onClick}
                />
            </div>
            <p
                className={classNames(s.text, {
                    [s.errorMessage]: errorMessage || innerApplePayError,
                })}
            >
                {innerApplePayError || errorMessage}
            </p>

            {isLoading && <PlacingOrderScreen />}
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    errorMessage: getApplePayOrderError(store),
    innerApplePayError: getApplePayInnerError(store),
    isLoading: getApplePayIsLoading(store),
    paymentDetails: getPaymentDetailsWithoutShipping(store),
});

export const PaymentApplePayButtonConnected = connect(mapStateToProps)(PaymentApplePayButton);
